module.exports = {"hello":"Merhaba!","language":"Dil"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/tr.json
// module id = 667
// module chunks = 1